<template>
  <div>
    <div id="wrapper" class="wrapper haslayout">
      <WebPortalHeader />
      <!--************************************
                    Main Start
            *************************************-->
      <main id="noticeFixWidth" class="Notice_mainsec">
        <!--************************************
                    DGME links Start
                *************************************-->
        <section class="haslayout st-shape-wrap">
          <div class="container-fluid">
            <div class="row" id="designedBackground">
              <div class="webportal-contant">
                <LeftSlider />
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                  <div class="row">
                    <div class="mid_contant">
                      <div
                        class="
                          col-xs-12 col-12 col-sm-12 col-md-12 col-lg-12
                          mt-5
                        "
                      >
                        <div class="row" id="blog-board">
                          <div
                            class="
                              col-xs-6 col-sm-6 col-md-6 col-lg-6
                              blog-board
                            "
                            v-for="(item, index) in getBlogData"
                            :key="index"
                          >
                            <article class="bg-post">
                              <figure>
                                <a
                                  id="forImageWidth"
                                  @click="blogDetailsView(item.id)"
                                >
                                  <v-img
                                    width="300px"
                                    height="300px"
                                    :src="item.cover_image"
                                    alt="image description"
                                  >
                                  </v-img>
                                </a>
                              </figure>
                              <div class="bg-postcontent">
                                <div class="bg-posttitle">
                                  <h3>
                                    <a
                                      href="javascript:void(0);"
                                      @click="blogDetailsView(item.id)"
                                      >{{ item.title }}</a
                                    >
                                  </h3>
                                </div>
                                <span class="bookwriter"
                                  >By
                                  <a
                                    href="javascript:void(0);"
                                    @click="blogDetailsView(item.id)"
                                    >{{ item.author.name }}</a
                                  ></span
                                >
                                <ul
                                  class="bg-postmetadata"
                                  style="padding-left: 0px !important"
                                >
                                  <li>
                                    <a
                                      href="javascript:void(0);"
                                      @click="blogDetailsView(item.id)"
                                      ><i class="fas fa-comment"></i> &nbsp;
                                      {{ item.comments_count }}
                                      {{
                                        item.comments_count < 2
                                          ? "Comment"
                                          : "Comments"
                                      }}</a
                                    >
                                  </li>
                                  <!-- <li><a 
                                                                    @click="blogDetailsView(item.id)"
                                                                    ><i class="fas fa-comment"></i><i>  {{item.reply_count}} Reply</i></a></li> -->
                                </ul>
                              </div>
                            </article>
                          </div>
                          <v-pagination
                            v-model="pagination.page"
                            class="my-4"
                            :length="paginationTotalPage"
                            total-visible="7"
                          ></v-pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <RightSlider />
              </div>
            </div>
          </div>
          <div class="st-shape2">
            <img src="../../assets/images/contact-shape1.svg" alt="shape2" />
          </div>
        </section>
        <!--************************************
                    DGME links Start
                *************************************-->
      </main>
      <!--************************************
                    Main End
            *************************************-->
      <WebPortalFooter />
    </div>
  </div>
</template>

<script>
import WebPortalHeader from "../../components/webPortalLayout/WebPortalHeader.vue";
import LeftSlider from "../../components/webPortalLayout/LeftSlider";
import RightSlider from "../../components/webPortalLayout/RightSlider";
import WebPortalFooter from "../../components/webPortalLayout/WebPortalFooter";
import { baseURL2 } from "@/store/api.js";
export default {
  data() {
    return {
      pagination: {
        page: 1,
        size: 6,
      },
      paginationTotalPage: null,
    };
  },

  name: "Blog",
  components: {
    WebPortalHeader,
    LeftSlider,
    RightSlider,
    WebPortalFooter,
  },
  created() {
    this.searchAllBlog();
    this.$store.dispatch("callHeaderFooterPublicData");
    // document.getElementById("noticeFixWidth").style.width = window.innerWidth;
    // document.getElementById("articleImage").style.width = document.getElementById("forImageWidth").offsetWidth;
  },
  computed: {
    getBlogData() {
      let url = this.$store.getters.getBlogData;
      url.forEach((element) => {
        if (element.cover_image) {
          element.cover_image = `${baseURL2}/${element.cover_image}`;
        } else {
          element.cover_image = "../../assets/images/contact-shape1.svg";
        }
      });
      return url;
    },
  },
  watch: {
    pagination: {
      handler(val) {
        this.searchAllBlog();
      },
      deep: true,
      immediate: false,
    },
  },
  methods: {
    blogDetailsView(id) {
      this.$router.push(`/blog-details/${id}`);
    },
    async searchAllBlog() {
      return this.$store
        .dispatch("callBlogPublicData", {
          page: this.pagination.page,
          size: this.pagination.size,
        })
        .then((result) => {
          return (this.paginationTotalPage = Math.ceil(
            result / this.pagination.size
          ));
        });
    },
  },
};
</script>

<style scoped>
.row {
  display: block;
  flex-wrap: wrap;
  flex: 1 1 auto;
}
</style>